import React, { useMemo } from 'react';
import { useSelector } from 'react-redux';

import VWAProductList from '../../../vwa/components/vwa-product-list';
import { transformProducts, transformHawkTiles } from '../../util';
import useProductImpressions from '../../../hooks/useProductImpressionsV2';
import useTestFlags from '../../../abtest/useTestFlags';
import CarouselCards from './carousel-cards';

import '../css/search-page-product.less';
import './integrated-page.less';

/**
 *
 * @param {*} props
 * @returns Tracks previous results
 */
const SearchPageIntegrated = ({ searchResults, hsResID, query, content, pStoreID, isLoading }) => {
    const siteConfig = useSelector(state => state && state.siteConfig);
    const vanityUrl = useSelector(state => state && state.slugInfo && state.slugInfo.vanityUrl);
    const { basename } = siteConfig || {};
    const { plpOrion } = useTestFlags(['plpOrion']);
    const { enabled: orionEnabled } = plpOrion || {};
    const transformOpts = { disableMktDiff: true, pickImage: orionEnabled };
    const products = transformProducts(searchResults, basename, transformOpts);

    const productsWithAnalytics = useProductImpressions({
        // products: (Keyword || '') === (searchKey || '') ? productBatch : null, // condition check is needed so searching within SRP triggers impressions correctly
        products,
        componentKey: 'hawksearchResults',
        list: 'search',
        vanityUrl,
        trackMetrics: true,
        trackerKey: query,
    });

    const banners = useMemo(() => {
        if (products?.length < 4) {
            return null;
        }

        const contentTiles = transformHawkTiles(content?.Results, pStoreID);
        const carousel = <CarouselCards cards={contentTiles} />;
        return [carousel];
    }, [content, pStoreID, products.length]);

    return (
        <div className={`hawk-results searchIntegrated${orionEnabled ? ' orion' : ''}`}>
            <VWAProductList
                products={productsWithAnalytics || new Array(3).fill({})}
                slugInfo={{
                    analyticsData: {
                        page_level: 'search',
                        hsResID,
                    },
                }}
                visId={!orionEnabled}
                tileContainerProps={{ className: 'srp-product-tile' }}
                useProductPromos={true}
                maxResultsPerPage={24}
                banners={banners}
                loadingList={isLoading}
                orionEnabled={orionEnabled}
                setDynamicBundleData={orionEnabled}
            />
        </div>
    );
};

export default SearchPageIntegrated;
